import React from 'react';
import IconWrapper from '../../../IconWrapper';
const ProgressIndicatorSpinnerIconMedium = (props) => (React.createElement(IconWrapper, { ...props },
    React.createElement("path", { d: "M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0v1.043c6.051 0 10.957 4.906 10.957 10.957 0 6.051-4.906 10.957-10.957 10.957C5.949 22.957 1.043 18.05 1.043 12H0Z" })));
export default ProgressIndicatorSpinnerIconMedium;
//# sourceMappingURL=ProgressIndicatorSpinnerIconMedium.js.map